import { Pipe, PipeTransform } from '@angular/core';
import { ServiceExtensions } from '../models/serviceExtensions';
import { SessionService } from '../services/session.service';

@Pipe({
    name: 'hasExtension',
    standalone: true
})
export class HasExtensionPipe implements PipeTransform {

	constructor(private sessionService: SessionService) {}

	transform(extension: ServiceExtensions): boolean {
		return this.sessionService.hasExtension(extension);
	}
}
